module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-th-TH.c1dfa563.jpg";